import React from 'react'

const RemainderSchedule = () => {
  return (
    <div>RemainderSchedule</div>
  )
}

export default RemainderSchedule